<template>
    <Panel title="Verfijn resultaten">
        <ExpandButton v-for="facet in facets" v-bind:key="facet.key" :title="facet.title" isOpen>
            <ul>
                <li v-for="value in facet.values" v-bind:key="value">
                    <Checkbox
                        :name="facet.key"
                        :value="value"
                        :checked="modelValue[facet.key] && modelValue[facet.key].includes(value)"
                        @change="onChange"
                    />
                </li>
            </ul>
        </ExpandButton>
    </Panel>
</template>

<script>
import Panel from './Panel.vue'
import ExpandButton from './ExpandButton.vue'
import Checkbox from './Checkbox.vue'

export default {
    name: 'FilterPanel',
    components: {
        Panel,
        ExpandButton,
        Checkbox,
    },
    props: {
        modelValue: Object,
        facets: Object,
    },
    methods: {
        onChange(e) {
            let newValue = { ...this.modelValue }

            if (!newValue[e.target.name]) {
                newValue[e.target.name] = []
            }

            if (e.target.checked && !newValue[e.target.name].includes(e.target.value)) {
                newValue[e.target.name].push(e.target.value)
            }

            if (!e.target.checked && newValue[e.target.name].includes(e.target.value)) {
                newValue[e.target.name] = newValue[e.target.name].filter(
                    (v) => v !== e.target.value
                )
            }

            this.$emit('update:modelValue', newValue)
        },
    },
}
</script>

<style scoped>
.expand-button:not(:last-child) {
    padding-bottom: 8px;
    border-bottom: 1px solid var(--color-grey-20);
}
</style>
